function checkdigit(value) {
  const sum = value.substring(0, 12)
    .split('')
    .map((n) => Number(n))
    .reduce((sum, digit, index) => {
      return sum + (digit * (index % 2 ? 3 : 1))
    });

  return ((10 - (sum % 10)) % 10).toString();
}

function micraJotaSale(fiscalReceipt) {
  if (!order && !payment) return { success: false, message: 'No order or payment' }
  let res = {}
  res.paymentsTotal = fiscalReceipt.paymentsTotal
  res.codes = []
  for (let [vatRegister, price] of Object.entries(fiscalReceipt.vatRegisterSums)) {
    let code = `23${(vatRegister + '').padStart(4, '0')}0${(price + '').padStart(5, '0')}`
    code += checkdigit(code)
    res.codes.push(code)
  }

  return res
}


export {
  micraJotaSale
}
